import { render, staticRenderFns } from "./usersPage.html?vue&type=template&id=35719fdc&"
import script from "./usersPage.vue?vue&type=script&lang=js&"
export * from "./usersPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports